import React from 'react';
import { motion } from 'framer-motion';
import { UnplugIcon, SplitIcon, EyeOffIcon } from 'lucide-react';
const pains = [{
  icon: SplitIcon,
  title: 'Data lives in a dozen silos',
  body: 'Ad spend in Meta, conversions in GA4, pipeline in Salesforce, product usage in Mixpanel. No one owns the full picture.'
}, {
  icon: EyeOffIcon,
  title: 'Attribution is guesswork',
  body: 'By the time you stitch it together in a spreadsheet, the numbers are stale and the story is broken.'
}, {
  icon: UnplugIcon,
  title: 'Signals arrive too late',
  body: 'The buying intent, the churn risk, the winning campaign — you see it days later, long after the moment to act has passed.'
}];
export function Problem() {
  return <section className="py-20 md:py-28" data-id="element-153">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-154">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.3fr] lg:gap-20" data-id="element-155">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="font-display text-4xl font-semibold leading-[1.05] tracking-tight md:text-6xl" data-id="element-156">
            Your revenue story is scattered across{' '}
            <span className="text-signal" data-id="element-157">too many tabs.</span>
          </motion.h2>

          <div className="flex flex-col divide-y divide-ink/10 border-t border-ink/10" data-id="element-158">
            {pains.map((p, i) => <motion.div key={p.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="flex gap-5 py-7" data-id="element-159">
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-ink text-signal" data-id="element-160">
                  <p.icon className="h-5 w-5" data-id="element-161" />
                </div>
                <div data-id="element-162">
                  <h3 className="text-xl font-semibold" data-id="element-163">{p.title}</h3>
                  <p className="mt-2 text-ink/60" data-id="element-164">{p.body}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}